import { number, oneOf, shape, string } from 'prop-types'

import { TemperatureSensorTypes } from '../../models/cold-chain/temperature-sensor-types-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { locationDescriptionBasePropType } from './location-description-base-prop-type'

/**
 * @typedef {Object} TemperatureSensor
 * @property {string} sensorCode
 * @property {string} sensorConfigId
 * @property {string} sensorDataId
 * @property {string} name
 * @property {string} type
 * @property {number} value
 * @property {ISO8601} dataTimestamp
 * @property {number} sortIndex
 * @property {object} [location]
 * @property {LocationDescriptionBase} [location.locationDescription]
 * @property {Position} [location.position]
 * @property {number} [lowerThreshold]
 * @property {number} [upperThreshold]
 */

export const temperatureSensorPropType = shape({
    sensorCode: string.isRequired,
    sensorConfigId: string.isRequired,
    sensorDataId: string.isRequired,
    name: string.isRequired,
    type: oneOf(Object.values(TemperatureSensorTypes)).isRequired,
    value: number.isRequired,
    dataTimestamp: iso8601PropType.isRequired,
    sortIndex: number.isRequired,
    location: shape({
        locationDescription: locationDescriptionBasePropType,
        position: positionPropType
    }),
    lowerThreshold: number,
    upperThreshold: number
})
